export default function () {
  const hasActiveMicroApp = document.querySelector(
    '.microapp-container.currentActive'
  )
  document.querySelectorAll('.microapp-container').forEach((item) => {
    item.style.setProperty('display', 'none')
  })
  if (hasActiveMicroApp) {
    hasActiveMicroApp.style.setProperty('display', 'initial')
  }
}
